import React, { ChangeEvent } from 'react'
import clsx from 'classnames'
import { Button } from '@/shared/ui'
import SearchSVG from '@/public/header-search.svg'
import CrossSVG from '@/public/input-cross.svg'
import style from './search-experts.module.scss'

type SearchExpertsProps = {
  value: string
  placeholder: string
  onChange: (value: string) => void
  wrapperClassName?: string
}

export const SearchExperts = (props: SearchExpertsProps) => {
  const { value, onChange, wrapperClassName, placeholder } = props
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    onChange(e.currentTarget.value)
  }

  const handleClear = () => {
    onChange('')
  }

  return (
    <div className={clsx(style.inputWrapper, wrapperClassName, { [style.active]: !!value })}>
      <span className={clsx(style.icon, style.search)}>
        <SearchSVG />
      </span>
      <input
        className={clsx('text text_type_t1', style.input)}
        autoFocus={false}
        value={value}
        placeholder={placeholder}
        onChange={handleChange}
      />
      {value && (
        <Button type="ghost" onClick={handleClear} className={clsx(style.icon, style.cross)}>
          <CrossSVG />
        </Button>
      )}
    </div>
  )
}
